<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("usermente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <!-- 検索欄 -->
      <b-tab :title="this.$i18n.t('usermente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="mailAddressSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('usermente.label_mailaddress')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="mailAddressSearch" :placeholder="this.$i18n.t('usermente.placeholder_mailaddress')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="opIdSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('usermente.label_user_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="opIdSearch" :placeholder="this.$i18n.t('usermente.placeholder_user_id')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="opNameSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('usermente.label_user_name')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="opNameSearch" :placeholder="this.$i18n.t('usermente.placeholder_user_name')"></b-form-input>
            </b-form-group>
            <div>
              <!-- 検索ボタン -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("usermente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
          <b-row class="d-flex align-items-center">
            <!-- アクション -->
            <b-col sm="2" md="2" class="my-1">
              <b-dropdown right variant="primary" :text=lblAction>
                <b-dropdown-item @click="valid" >{{ $i18n.t("usermente.button_valid") }}</b-dropdown-item>
                <b-dropdown-item @click="invalid" >{{ $i18n.t("usermente.button_invalid") }}</b-dropdown-item>
                <b-dropdown-item @click="download(1)" >{{ $i18n.t("usermente.download_barcode") }}</b-dropdown-item>
                <b-dropdown-item @click="download(2)" >{{ $i18n.t("usermente.download_qrcode") }}</b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col sm="2" md="2" class="my-1">
              <div>{{ $i18n.t("usermente.label_num_of_disp") }}
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  style="width: auto"
                ></b-form-select>
              </div>
            </b-col>
            <b-col sm="8" md="8" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)" name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <!-- 編集ボタン -->
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("usermente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("usermente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('usermente.tab_register')">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="mailAddressForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_mailaddress_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="mailAddressForm" :placeholder="this.$i18n.t('usermente.placeholder_mailaddress')" maxlength="100"></b-form-input>
            </b-form-group>
            <b-form-group
              id="mailAddressForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_user_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="opNameForm" :placeholder="this.$i18n.t('usermente.placeholder_user_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="selectedGroupList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_group')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selectedGroupList" :options="options" multiple :select-size="5" v-on:change="getSelectedGroup" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="passwordForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_password')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="passwordForm" type="password" :placeholder="this.$i18n.t('usermente.placeholder_user_password')" maxlength="100"></b-form-input>
            </b-form-group>
            <b-form-group
              id="passwordCheckForm"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('usermente.label_password_check')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="passwordCheckForm" type="password" :placeholder="this.$i18n.t('usermente.placeholder_user_password_confirm')" maxlength="100"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("usermente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('usermente.info_register')" :titleMsg="this.$i18n.t('usermente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('usermente.info_valid')" :titleMsg="this.$i18n.t('usermente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <confirm-modal modId="md-confirm3" :msg="this.$i18n.t('usermente.info_invalid')" :titleMsg="this.$i18n.t('usermente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  created () {
    // 所属グループ取得
    var reqObj = {}
    var headers = {
      'Content-Type': 'application/json',
      'opid': this.$store.store.state.opId,
      'ticketid': this.$store.store.state.ticketId
    }
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/group/select', reqObj, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var groupList = res.data.group
          var groups = []

          // 整形
          for (var i = 0; i < groupList.length; i++) {
            var group = {}
            group.value = groupList[i].group_id
            group.text = groupList[i].group_name
            groups.push(group)
          }
          // 一旦データクリア
          this.options.splice(0)
          // データセット
          this.options.splice(0, 0, ...groups)
        }
      })
      .catch(err => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(err)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
      })

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        // 配列として渡されてしまうため先頭の値のみ取得
        var searchOpId = this.$route.query.searchOpId
        this.opIdSearch = searchOpId[0]
        var searchMailAddress = this.$route.query.searchMailAddress
        this.mailAddressSearch = searchMailAddress[0]
        var searchOpName = this.$route.query.searchOpName
        this.opNameSearch = searchOpName[0]
        this.search()
      }
    }
  },
  components: {
    confirmModal
  },
  data () {
    return {
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      fields: [
        { key: 'action', label: '' },
        { key: 'mailAddress', label: this.$i18n.t('usermente.label_mailaddress'), sortable: true },
        { key: 'opId', label: this.$i18n.t('usermente.label_user_id'), sortable: true },
        { key: 'opName', label: this.$i18n.t('usermente.label_user_name'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('usermente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('usermente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('usermente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('usermente.button_edit') }
      ],
      items: [],
      options: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      isAllSelected: false,
      selectedItems: [],
      selectedGroups: [],
      lblAction: this.$i18n.t('usermente.button_action'),
      mailAddressForm: null,
      opNameForm: null,
      passwordForm: null,
      passwordCheckForm: null,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    search: function () {
      // リクエスト
      var reqObj = {}
      var mailAddressStr = this.mailAddressSearch
      if (mailAddressStr == null) {
        mailAddressStr = ''
      }
      var opIdStr = this.opIdSearch
      if (opIdStr == null) {
        opIdStr = ''
      }
      var opNameStr = this.opNameSearch
      if (opNameStr == null) {
        opNameStr = ''
      }

      reqObj.opId = opIdStr
      reqObj.mailAddress = mailAddressStr
      reqObj.opIdLikeFlg = '1'
      reqObj.mailAddressLikeFlg = '1'
      reqObj.opName = opNameStr
      reqObj.efFlg = ''

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/select', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var userList = res.data.userInfo
            var users = []
            if (userList.length === 0) {
              this.errSbj = this.$i18n.t('usermente.title')
              this.errMsg = this.$i18n.t('usermente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < userList.length; i++) {
              var user = {}
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(userList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              var output = null
              if (String(utc) === 'Invalid date') {
                output = ''
              } else {
                // local時刻に変換＆フォーマット
                output = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              user.opId = userList[i].op_id
              user.mailAddress = userList[i].mail_address
              user.opName = userList[i].op_name
              user.uOp = userList[i].u_op_name
              user.uDate = output
              user.groupId = userList[i].groupId
              // TODO json
              user.edit = this.$i18n.t('usermente.label_edit')
              user.efFlg = userList[i].ef_flg
              if (userList[i].ef_flg === '1') {
                // TODO json
                user.efFlgStr = this.$i18n.t('usermente.label_valid')
              } else {
                // TODO json
                user.efFlgStr = this.$i18n.t('usermente.label_invalid')
                user.status = 'awesome'
              }
              user.selectedFlg = false
              user.index = i
              users.push(user)
            }
            // ページング設定
            this.totalRows = users.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...users)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.mailAddressForm === null || this.mailAddressForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_user_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkMail(this.mailAddressForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_not_mail')
        this.$bvModal.show('md-err')
        return
      }
      if (this.opNameForm === null || this.opNameForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_user_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.opNameForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_user_name_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.passwordForm === null || this.passwordForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_pass_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.passwordForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_pass_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.passwordForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_pass_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.passwordForm.length < 8) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_pass_tooshort')
        this.$bvModal.show('md-err')
        return
      }
      if (this.passwordCheckForm === null || this.passwordCheckForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_pass_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.passwordForm !== this.passwordCheckForm) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.password_not_match')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mailAddress = this.mailAddressForm
      reqObj.opName = this.opNameForm
      reqObj.groupId = this.selectedGroups
      reqObj.password = this.passwordForm

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/register', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          alert(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.mailAddressForm = null
      this.opNameForm = null
      this.passwordForm = null
      this.passwordCheckForm = null
      this.selectedGroups = []
      this.$bvModal.hide('md-confirm')
    },
    valid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(this.items[i].opId)
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '1'
      reqObj.opId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    invalid: function () {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(this.items[i].opId)
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      // 対象にログインユーザが含まれていないかチェック
      if (this.selectedItems.indexOf(this.$store.store.state.opId) !== -1) {
        // 存在する
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.loginuser_del_err')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.mode = '0'
      reqObj.opId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/updateEfFlg', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            this.$bvModal.show('md-confirm3')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    download: function (flg) {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(this.items[i].opId)
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('usermente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      // 行数列数等は仮で固定
      var body = {}
      body.opId = this.selectedItems
      body.startRow = 1
      body.startColumn = 1
      body.barKind = flg
      body.column = 4
      if (flg === 1) {
        body.row = 15
      } else {
        body.row = 8
      }
      body.language = this.$store.store.getters.getLang
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/operator/barcode', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            console.log(res)
            var fileName = 'usermente_' + this.$moment().format('YYYYMMDDHHmmss')
            console.log(fileName)
            this.downloadPdf(res.data.url, fileName)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downloadPdf: function (url, fileName) {
      this.$axios
        .get(url, {
          responseType: 'blob',
          dataType: 'binary'
        })
        .then(res => {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(res.data, fileName + '.pdf')
          } else {
            // for chrome, firefox
            const url = URL.createObjectURL(
              new Blob([res.data], {type: 'application/pdf'})
            )
            const linkEl = document.createElement('a')
            linkEl.href = url
            linkEl.setAttribute('download', fileName + '.pdf')
            document.body.appendChild(linkEl)
            linkEl.click()
            URL.revokeObjectURL(url)
            linkEl.parentNode.removeChild(linkEl)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm2')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    edit: function (item, index, button) {
      // 検索条件保持(戻るボタン対応)
      var mailAddressStr = this.mailAddressSearch
      if (mailAddressStr == null) {
        mailAddressStr = ''
      }
      var opIdStr = this.opIdSearch
      if (opIdStr == null) {
        opIdStr = ''
      }
      var opNameStr = this.opNameSearch
      if (opNameStr == null) {
        opNameStr = ''
      }
      this.$store.store.state.searchOpId = opIdStr
      this.$store.store.state.searchMailAddress = mailAddressStr
      this.$store.store.state.searchOpName = opNameStr

      // 編集データ
      this.$store.store.state.opIdForm = item.opId
      this.$store.store.state.mailAddress = item.mailAddress
      this.$store.store.state.opName = item.opName
      this.$store.store.state.groupId = item.groupId
      this.$router.push({ path: 'usermenteEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    // セレクトされたグループの値を取得
    getSelectedGroup: function (selected) {
      this.selectedGroups = []
      var splitlist = selected
      this.selectedGroups = splitlist
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Usermente.vue